import React from 'react';

import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

class NotFound extends React.Component {

    constructor(props) {
        super(props);

        this.props.updateLoader({
            loaded: true,
            message: ""
        });
    }

    render() {
        return (
            <div className="alert alert-warning" role="alert">
                <h5>404</h5>
                <p className="mt-3">Запрашиваемая страница не найдена</p>
            </div>
        )
    }
}

export default NotFound;